export default "__VITE_ASSET__9c992583__"